module.exports = __webpack_public_path__ + "assets/img/G4.2096af53.png";